var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qas',{attrs:{"permission-menu":4}})
}
var staticRenderFns = []

export { render, staticRenderFns }